import { useContext } from 'react'
import { AlertContext } from '../components/common/Alert/AlertProvider'

function useAlert() {
  const { error, addError, removeError } = useContext(AlertContext)
  return { error, addError, removeError }
}


export default useAlert
